import { getHttpClient, errorDesconocido, safeHandle401 } from "../../../core/utils/httpClient";

//import es_AR from "../../../../utils/locale/es-AR";
//import es_UY from "../../../../utils/locale/es-UY";
//import es from "../../../../utils/locale/es";

export function error(error) {
    return { type: "CONFIG_MIGRACION_ERROR", error };
}

export function loading(loading) {
    return { type: "CONFIG_MIGRACION_LOADING", loading };
}

export function success(data) {
    return { type: "CONFIG_MIGRACION_SUCCESS", data };
}

export function migrarBarriles(form) {
    return async (dispatch, getState) => {
        dispatch(reset());
        dispatch(loading(true));
        dispatch(error(""));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.post("react/v1/instalador/barriles", form, { headers: headers });

            dispatch(success(response.data));
            dispatch(loading(false));

            return response.data;
        } catch (e) {
            dispatch(loading(false));
            const test401 = safeHandle401(dispatch, getState);
            test401(e);

            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                    alert("Error 404 ");
                } else if (e.response.status != 400) {
                    alert("Error desconocido");
                }

                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function reset() {
    return { type: "CONFIG_MIGRACION_RESET" };
}
